/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MenuInputs */

const es_nav_menu = /** @type {(inputs: Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const gl_nav_menu = /** @type {(inputs: Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const en_nav_menu = /** @type {(inputs: Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Nav_MenuInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_menu = /** @type {((inputs?: Nav_MenuInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MenuInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_menu(inputs)
	if (locale === "en") return en_nav_menu(inputs)
	return es_nav_menu(inputs)
});